module.exports = "/_next/static/images/Hero@2x-1b6d27eee51280903a9a6f534efdcf44.png";